<div class="fluid formgrid grid">
  <div class="field col-1 xl:col-1 sm:col-3">
    <label for="DN1S" class="do-not-wrap-text">Номер </label>
    <input id="DN1S" type="text" pInputText [value]="newDocument.DOCNUMBER" readonly />
  </div>
  <div #DDP class="field col-1 xl:col-1 sm:col-3">
    <label for="DD" class="do-not-wrap-text">{{data1Label}} </label>
    <p-calendar id="DD" [dateFormat]="dateFormat" [showTime]="showTime" [(ngModel)]="DOCDATE" (onSelect)="onDateSelect($event)" showButtonBar="true" firstDayOfWeek="1"></p-calendar>
  </div>
  <div #DDE class="field col-1 xl:col-1 sm:col-3">
    <label for="DV" class="do-not-wrap-text">{{data2Label}} </label>
    <p-calendar id="DV" [dateFormat]="dateFormat" [(ngModel)]="DOCVALDATE" [minDate]="DOCDATE" (onSelect)="onDateValSelect($event)" showButtonBar="true" firstDayOfWeek="1"></p-calendar>
  </div>
  <div #DDV class="field col-1 xl:col-1 sm:col-3">
    <label for="DE" class="do-not-wrap-text">{{data3Label}} </label>
    <p-calendar id="DE" [dateFormat]="dateFormat" [(ngModel)]="DOCEXPDATE" [minDate]="DOCDATE" (onSelect)="onDateExpSelect($event)" showButtonBar="true" firstDayOfWeek="1"></p-calendar>
  </div>
  <div class="field col-4 xl:col-4 sm:col-6">
    <app-currencyselector #cs1 labelKey="{{currLabel}} {{newDocument.DOCRATEVAL}}" [selectedID]="newDocument.DOCCURRID"
                          [_currencyDate]="DOCDATE" (SelectedCurrency)="onCurrencySelection($event)"></app-currencyselector>
  </div>

  <div class="field col-4 xl:col-4 sm:col-12">
    <app-security-group-selector #sgs1 [labelKey]="sgrpLabel" [selectedID]="newDocument.SGMGROUPID" (onSelectedSecurityGroup)="onSelectedSecurityGroup($event)"></app-security-group-selector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12">
    <app-companyselector [labelKey]="lcoLabel" [parentCompany]="newDocument.DOCMANCLIID"
                         [selectedID]="newDocument.DOCLCOCLIID" (selectedCompanyID)="lcoCompanySelected($event)"></app-companyselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12">
    <app-personselector [labelKey]="pcoPerLabel" [parentCompany]="newDocument.DOCMANCLIID" [disabled]="true"
                        [selectedID]="newDocument.DOCMANPERID" (selectedPersonID)="newDocument.DOCMANPERID=$event"></app-personselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12" *ngIf="selectDepartmentOn">
    <app-departmentselector labelKey="{{manDepLabel}} ({{newDocument.DOCLCODEPID}})"
                            [parentCompany]="newDocument.DOCMANCLIID"
                            [selectedID]="newDocument.DOCMANDEPID"
                            (selectedDepartmentID)="mainStockSelected($event)"></app-departmentselector>
  </div>

</div>
